export default __webpack_public_path__ + "static/media/bg-flag.c3282e1f.svg";